import React, { useContext, useEffect, useState } from "react";
import { graphql, navigate, useStaticQuery } from "gatsby";
import FormHead from "../../molecules/form-head/FormHead";
import FormBody from "../../molecules/form-body/FormBody";
import GlobalContext from "../../../contexts/globalContext";
import { saveForm, getToken } from "../../../services/formServices";
import Modal from "../../ui/modal/Modal";
import moment from "moment";

//Styles
import "./FormRegistroConversacionForo.scss";
import rawToReact from "../../../utils/rawToReact";

interface FormRegistroConversacionForoProps {
    displayForm: boolean;
    setDisplayForm: (state: boolean) => void;
}

const FormRegistroConversacionForo = (props: FormRegistroConversacionForoProps) => {
    
    const data = useStaticQuery(graphql`
        query contentfulFormRegistroConversacionForo {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "6XvR0K4MGtDRNiiBeEUC7H" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            placeholder
                            obligatorio
                            seccion
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "mz9ezPUpRj1VwTb1IjpcP" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);
    const contentfulData = data.form.nodes[0];
    const modalSuccess = data.modalSuccess.nodes[0];
    const Context = useContext(GlobalContext);
    const defaultFormValues = {
        fecCreacion: "",
        nombreLider: "",
        tipoDoc: "",
        numDoc: "",
        titulo: "",
        categoria: "",
        descripcion: ""
      };
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [displayModal, setDisplayModal] = useState<boolean>(false);
    const [formValues, setFormValues] = useState(defaultFormValues);

    const updateInputValue = (field: string, value: any, type?: string) => {
        setFormValues((prev) => {
            return { ...prev, [field]: value };
        });
    };

    const createPayload = () => {
        const payload: any = {
            idForm: 12,
            answers: []
        };
        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        return payload;
    };

    useEffect(() => {
        let tituloElm:HTMLTextAreaElement = document.querySelector("#text-area-titulo")!;
        if (tituloElm) tituloElm.maxLength = 100;
        let descripcionElm:HTMLTextAreaElement = document.querySelector("#text-area-descripcion")!;
        if (descripcionElm) descripcionElm.maxLength = 350;
    });

    const closeForm = (status) => {
        props.setDisplayForm(false);
        setDisabledButton(false);
        if (status == "undefined" || status == "") {
            setDisplayModal(false);
        }
        else if (status === 200) {
            setDisplayModal(true);
            let auxValues = {...formValues};
            setTimeout(() => {
                if (document.querySelector(".modal-success-data__titulo__valor")) {
                    document.querySelector(".modal-success-data__titulo__valor")!.textContent = auxValues.titulo;
                    document.querySelector(".modal-success-data__categoria__valor")!.textContent = auxValues.categoria;
                }
            }, 750);
        } else {
            alert("ERROR AL GUARDAR SOLICITUD");
        }
        setFormValues(defaultFormValues);
    };

    const handleSubmitForm = async () => {
        setDisabledButton(true);
        try {
            const payload = createPayload();
            const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
            const response = await saveForm(payload, token);
            closeForm(response.data.status);
        } catch (error) {
            closeForm(400);
            console.log(error);
        }
    };

    const handleCancelButton = async () => {
        setDisplayModal(false);
        closeForm("");
    };

    useEffect(() => {
        if (Context.gigyaContext.gigyaAccount) {
            setFormValues({
                ...formValues,
                fecCreacion: moment(Date.now()).format('DD-MM-YYYY'),
                nombreLider: Context.gigyaContext.gigyaAccount.profile.firstName + " " + Context.gigyaContext.gigyaAccount.profile.lastName,
                tipoDoc: Context?.gigyaContext?.gigyaAccount?.data.docType, 
                numDoc: Context?.gigyaContext?.gigyaAccount?.data.docNumber
            });
        } else {
            setInputDisabled([]);
        }
    }, [Context.gigyaContext.gigyaAccount]);

    useEffect(() => {
        document.body.style.overflow = displayModal ? "hidden" : "unset";
    }, [displayModal]);

    return (
        <>
            {props.displayForm && (
                <Modal showModal={props.displayForm} onClose={() => closeForm("")}>
                    <div className="o-form-registro-conversacion-foro">
                        <div className={`o-form-registro-conversacion-foro__container ${Context.gigyaContext.gigyaAccount ? "--disable-input" : ""}`}>
                            <FormHead
                                tituloPrincipal={contentfulData.tituloPrincipal}
                                descripcion={contentfulData.descripcion}
                                tituloFormulario={contentfulData.tituloFormulario}
                                descripcionFormulario={JSON.parse(contentfulData.descripcionFormulario.raw)}
                            />

                            {/* Renderiza el cuerpo del formulario */}
                            <FormBody
                                titulosFormulario={contentfulData.titulosFormulario}
                                genericClassNameForm={contentfulData.metaTitulo}
                                setInputValue={updateInputValue}
                                formValues={formValues}
                                handleSubmitForm={handleSubmitForm}
                                handleCancelButton={handleCancelButton}
                                inputDisabled={inputDisabled}
                                isDisabledButton={isDisabledButton}
                            />
                        </div>
                    </div>
                </Modal>
            )}

            {displayModal && (
                <Modal showModal={displayModal} onClose={() => setDisplayModal(false)}>
                    <div className='modal-success'>
                        <div className="modal-success-title">
                            <h1>{modalSuccess.tituloPrincipal}</h1>
                        </div>
                        <div className="modal-success-description">
                            {rawToReact(modalSuccess.descripcionFormulario.raw)}
                        </div>

                        <hr/>

                        <br/>
                        <br/>
                        
                        <div className="modal-success-data">
                            <div className="modal-success-data__titulo">
                                <div className="modal-success-data__titulo__label">
                                    <strong>Título de conversación:</strong>
                                </div>
                                <div className="modal-success-data__titulo__valor">
                                </div>
                            </div>
                            <br/>
                            <div className="modal-success-data__categoria">
                                <div className="modal-success-data__categoria__label">
                                    <strong>Categoría:</strong>
                                </div>
                                <div className="modal-success-data__categoria__valor">
                                </div>
                            </div>
                        </div>

                        <br/>
                        <br/>

                        <hr/>

                        <br/>
                        <br/>

                        <div className="modal-success-button">
                            <button type="button" onClick={() => setDisplayModal(false)}>{modalSuccess.tituloBoton}</button>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default FormRegistroConversacionForo;
